module.exports = __webpack_public_path__ + "static/media/mt.9da5393f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Impact/img/mt.jpeg
// module id = 297
// module chunks = 0